<div class="dashboard-page">
  <div class="container">
    <h1>{{ 'dashboard' | translate }}</h1>
    <p>{{ 'dashboard-placeholder-text' | translate }}</p>
  </div>
</div>
